<template>
  <div class="d-flex flex-column flex-grow-1">
    <div class="selector-container section-container d-flex" :class="{'dark':skinType}">
       <SectionTitle title="方案报告" ></SectionTitle>
      <el-form :inline="true" ref="form" class="none-width flex-grow-1"
       :model="form" style="text-align: left" size="small">
        <el-form-item label="项目" v-if="projectList" :class="{'light-label':skinType}">
          <el-select class="form-item" v-model="form.selectProjectId" placeholder="请选择">
            <el-option
              v-for="(project, index) of projectList"
              :key="index"
              :label="project.ModelName"
              :value="project.IdStr"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期" :class="{'light-label':skinType}">
          <el-date-picker
            v-model="form.selectPeriod"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            class="form-item"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="关键字" :class="{'light-label':skinType}">
          <el-input class="form-item  form-item-keywords" v-model="form.keys" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="" type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="addNew">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table size="small"
      :data="tableData"
      class="none-height flex-grow-1 d-flex flex-column"
      style="width: 100%"
      @row-click="rowClickListener"
            stripe
      :class="{'dark':skinType}"
      :row-class-name="(...nu)=>{return skinType?'dark text-white':''}"
    >
      <el-table-column label="#" type="index" width="60"> </el-table-column>
      <el-table-column prop="F_CreatorTime" label="时间"> </el-table-column>
      <el-table-column prop="ReportName" label="报告名称"> </el-table-column>
      <el-table-column prop="StationName" label="所属配电室"></el-table-column>
      <el-table-column prop="ProjectName" label="所属项目"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleModify(scope.$index, scope.row)"
            >修改</el-button
          >
          <el-button
            size="mini"
            @click="handleDownload(scope.$index, scope.row)"
            >下载</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="d-flex section-container" style="padding:1rem;" :class="{'dark':skinType}">
      <el-pagination
        v-if="pageInfo.total"
        style="margin-left: auto"
        background
        :class="{'text-white':skinType}"
        layout="total, prev, pager, next"
        :total="pageInfo.total"
        :current-page.sync="pageIndex"
      >
      </el-pagination>
    </div>
    <el-dialog :title="diaTitle" :visible.sync="dialogVisible"
    :class="{'dark':skinType}">
      <el-form ref="postForm" :model="selectFormReport" label-width="120px">
        <el-form-item label="报告名称">
          <el-input v-model="selectReport.ReportName"></el-input>
        </el-form-item>
        <el-form-item v-if="projectList" label="所属项目" style="text-align: left">
          <el-select
            v-model="selectFormReport.ProjectIDstr"
            placeholder="请选择项目"
            @change="selectProjectListener"
          >
            <el-option
              v-for="(project, index) of projectList"
              :key="index"
              :label="project.ModelName"
              :value="project.IdStr"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: left" v-if="selectFormProject.Children" label="所属配电室">
          <el-select
            v-model="selectFormReport.StationIDstr"
            placeholder="请选择配电室"
            @change="selectRoomListener"
          >
            <el-option
              v-for="(room, index) of selectFormProject.Children"
              :key="index"
              :label="room.ModelName"
              :value="room.IdStr"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: left" label="报告日期">
          <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="selectFormReport.ReportDate"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="附件" style="text-align: left;">
          <el-button v-if="selectFormReport.FilePath&&!modifyFile"
           type="" v-on:click="modifyFile=true">更改文件</el-button>
          <el-input v-else type="file" ref="fileInput"
           v-model="selectFormReport.FilePath"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="postForm">确认</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import SectionTitle from '@/components/utils/section-title.vue';
import { BASE_URL } from '@/utils/request/request';
import {
  getProjectReports,
  addProjectReport,
  modifyProjectReport,
} from '@/api/equipments/equipments';
import { formatDate, convertDataToFormData } from '@/utils/utils';

export default {
  name: 'reports',
  components: {
    SectionTitle,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      modifyFile: false,
      // 是否新报告
      isNew: false,
      diaTitle: '',
      form: {
        selectProjectId: null,
        keys: null,
        selectPeriod: [
          formatDate(new Date(), 'yyyy-MM-01'),
          formatDate(new Date(), 'yyyy-MM-dd'),
        ],
      },
      // 是否展示dialog
      dialogVisible: false,
      selectReport: {},
      selectFormReport: {},
      pageInfo: {
        index: 1,
        size: 10,
        total: 1,
      },
      tableData: [],
      selectFormProject: null,
      selectFormRoom: null,
      pageIndex: 1,
    };
  },
  created() {
    this.requestProjectList();
  },
  computed: {
    projectList() {
      return this.$store.getters.projectList;
    },
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  watch: {
    pageInfo: {
      deep: true,
      handler() {
        this.requestProjectReports();
      },
    },
    selectProjectId() {
      this.requestProjectReports();
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.modifyFile = false;
      }
    },
    projectList() {
      this.initialData();
    },
  },
  methods: {
    selectProjectListener(val) {
      this.selectFormProject = this.projectList.find((item) => item.IdStr === val);
      if (this.selectFormProject.Children) {
        [this.selectFormRoom] = this.selectFormProject.Children;
      }
    },
    selectRoomListener(val) {
      this.selectFormRoom = this.selectFormProject.Children.find((item) => item.IdStr === val);
    },
    // 添加、修改报告
    postForm() {
      this.selectFormReport.ProjectName = this.selectFormProject.ModelName;
      this.selectFormReport.StationName = this.selectFormRoom.ModelName;
      console.log(this.selectFormReport);
      const formData = convertDataToFormData(this.selectFormReport);
      if (this.modifyFile || this.isNew) {
        const [selectFile] = this.$refs.fileInput.$el.querySelector('input').files;
        if (selectFile) {
          formData.set('FilePath', selectFile, selectFile.name);
        }
      }

      // 提交表单
      this.addModifyReport(formData).then((res) => {
        console.log('res', res);
        this.modifyFile = false;
        this.dialogVisible = false;
        if (!this.isNew) {
          this.selectReport = Object.assign(this.selectReport, this.selectFormReport);
        } else if (this.pageIndex !== 1) {
          this.pageIndex = 1;
        } else {
          this.requestProjectReports();
        }
        console.log(this.selectReport);
      });
    },
    // 添加、修改报告
    addModifyReport(formData) {
      if (this.isNew) {
        return addProjectReport(formData);
      }
      return modifyProjectReport(formData);
    },
    // 更新报告
    handleModify(index, report) {
      this.isNew = false;
      this.diaTitle = '修改';
      this.selectReport = report;
      this.selectFormReport = {
        ...report,
        RIDstr: report.TabIDstr,
      };
      this.dialogVisible = true;
    },
    // 添加新报告
    addNew() {
      this.isNew = true;
      this.diaTitle = '添加';
      this.selectFormReport = {};
      this.selectReport = {};
      this.dialogVisible = true;
    },
    initialData() {
      const [firstProject] = this.projectList;
      this.selectFormProject = firstProject;
      this.$set(this.selectFormReport, 'ProjectIDstr', firstProject.IdStr);
      this.form.selectProjectId = firstProject.IdStr;
      this.requestProjectReports();
    },
    requestProjectList() {
      if (this.projectList !== null) {
        this.initialData();
        return;
      }
      this.$store.dispatch('projects/projectList');
    },
    requestProjectReports() {
      if (!this.form.selectProjectId) {
        return;
      }
      const [start, end] = this.form.selectPeriod;
      getProjectReports({
        ProjectIDstr: this.form.selectProjectId,
        ReportName: this.form.keys,
        StationIDstr: null,
        BeginTime: start,
        EndTime: end,
        page: this.pageIndex,
        rows: this.pageInfo.size,
      })
        .then((res) => {
          this.pageInfo.total = res.total || 0;
          this.tableData = res.list || res;
        })
        .catch(() => {
          this.tableData = [];
          this.pageInfo.total = 0;
        });
    },
    // 行点击监听
    rowClickListener(row) {
      console.log(row);
    },
    // 预览文件
    handlePreview(index, row) {
      window.open(
        `http://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
          BASE_URL + row.FilePath,
        )}`,
      );
    },
    // 下载文件
    handleDownload(index, row) {
      //console.log("-------"+`${BASE_URL}${row.FilePath}`);
      window.open(`${BASE_URL}${row.FilePath}`);
    },
    onSubmit() {
      this.requestProjectReports();
    },
  },
};
</script>

<style lang="less" scoped>
.form-item {
 width: 210px;
}
.form-item-keywords{
  width:150px;
}
</style>
